<template>
  <v-list
    v-if="isToolListText && !shrinkToXS && isToolListCollapsedText"
    class="pa-0 pt-1"
    color="widgetsList" dark flat
    :dense="denseToolbox">
    <v-list-item-group>
      <template v-for="(menuItem, index) in menuItemsTools">
        <template v-if="!menuItem.group">
          <v-list-item
            :id="menuItem.id" :key="menuItem.title" link
            :style="{
              borderLeft:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListLeft
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              borderRight:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListRight
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              backgroundColor:
                menuItem.id === activeTool || menuItem.id === centerActiveTool
                  ? 'rgb(255, 255, 255, 0.24)' : '',
            }"
            :ripple="false"
            @click="startTool(menuItem)">
            <BaseTooltip right>
              <template #activator="{on, attrs}">
                <v-icon
                  class="mr-4"
                  dense
                  v-bind="attrs"
                  :color="menuItem.id === activeTool || menuItem.id === centerActiveTool ? selectedIconColor : iconColor"
                  v-on="on">
                  {{ menuItem.icon }}
                </v-icon>
              </template>
              <span>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</span>
            </BaseTooltip>
          </v-list-item>
        </template>
        <template v-else-if="index">
          <v-divider :key="menuItem.title + Math.random()" color="gray" />
        </template>
      </template>
    </v-list-item-group>
  </v-list>
  <v-list
    v-else-if="isToolListText && !shrinkToXS"
    class="pa-0 pt-1"
    color="widgetsList" dark flat
    :dense="denseToolbox">
    <v-list-item-group>
      <template v-for="menuItem in menuItemsTools">
        <template v-if="!menuItem.group">
          <v-list-item
            :id="menuItem.id" :key="menuItem.title" link
            :style="{
              borderLeft:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListLeft
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              borderRight:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListRight
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              backgroundColor:
                menuItem.id === activeTool || menuItem.id === centerActiveTool
                  ? 'rgb(255, 255, 255, 0.24)' : '',
            }"
            :ripple="false"
            @click="startTool(menuItem)">
            <v-icon
              class="mr-4"
              dense
              :color="menuItem.id === activeTool || menuItem.id === centerActiveTool ? selectedIconColor : iconColor">
              {{ menuItem.icon }}
            </v-icon>

            <v-list-item-title
              :style="{
                color:
                  iconColor

              }">
              {{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-else>
          <v-subheader
            :key="menuItem.title + Math.random()" :style="{
              color:
                iconColor

            }" class="tertiary--text font-weight-thin">
            {{ menuItem.title }}
          </v-subheader>
          <v-divider :key="menuItem.title + Math.random()" color="gray" />
        </template>
      </template>
    </v-list-item-group>
  </v-list>
  <v-list
    v-else-if="(isToolListLeft || isToolListRight) && !shrinkToXS"
    class="pa-0 pt-1"
    color="widgetsList" dark flat
    :dense="denseToolbox">
    <v-list-item-group>
      <template v-for="menuItem in menuItemsTools">
        <v-list-item
          v-if="!(menuItem.id === 'editor' && viewType === '3d')"
          :id="menuItem.id" :key="menuItem.title" link
          :style="{
            borderLeft:
              (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListLeft
                ? 'solid 3px ' + selectedIconBorderColor
                : 'solid 3px rgb(255, 255, 255, 0)',
            borderRight:
              (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListRight
                ? 'solid 3px ' + selectedIconBorderColor
                : 'solid 3px rgb(255, 255, 255, 0)',
            backgroundColor:
              menuItem.id === activeTool || menuItem.id === centerActiveTool
                ? 'rgb(255, 255, 255, 0.24)' : '',
          }"
          :ripple="false"
          @click="startTool(menuItem)">
          <v-list-item-content>
            <BaseTooltip :right="isToolListLeft" :left="isToolListRight">
              <template #activator="{on, attrs}">
                <v-icon
                  dense
                  :color="menuItem.id === activeTool || menuItem.id === centerActiveTool ? selectedIconColor : iconColor"
                  v-bind="attrs"
                  v-on="on">
                  {{ menuItem.icon }}
                </v-icon>
              </template>
              <span>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</span>
            </BaseTooltip>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list-item-group>
  </v-list>
  <v-slide-group
    v-else-if="isToolListFooter || shrinkToXS" multiple show-arrows
    dark>
    <template v-for="menuItem in menuItemsTools">
      <v-slide-item
        v-if="!(menuItem.id === 'editor' && viewType === '3d')"
        :key="menuItem.title"
        v-slot="{active}"
        :style="{
          borderBottom:
            menuItem.id === activeTool || menuItem.id === centerActiveTool
              ? 'solid 3px ' + selectedIconBorderColor
              : '',
          backgroundColor:
            menuItem.id === activeTool ? selectedIconColorFooter : '',
        }">
        <v-btn
          :input-value="active"
          text
          :rounded="false"
          tile
          height="52"
          @click="startTool(menuItem)">
          <BaseTooltip top>
            <template #activator="{on, attrs}">
              <v-icon
                :color="menuItem.id === activeTool || menuItem.id === centerActiveTool ? selectedIconColor : iconColor"
                size="24px" v-bind="attrs" v-on="on">
                {{ menuItem.icon }}
              </v-icon>
            </template>
            <span>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</span>
          </BaseTooltip>
        </v-btn>
      </v-slide-item>
    </template>
  </v-slide-group>
  <div v-else-if="isToolListDialog && !shrinkToXS" align="center" justify="center">
    <v-card
      tile color="widgetsList" class="text-center"
      dark>
      <v-card-text>
        <v-row align="center" justify="center">
          <template v-for="menuItem in menuItemsTools">
            <v-col
              v-if="!(menuItem.id === 'editor' && viewType === '3d')"
              :key="menuItem.title"
              cols="12" sm="2" align-self="center"
              class="px-0"
              :style="{
                border:
                  menuItem.id === activeTool || menuItem.id === centerActiveTool
                    ? 'solid 3px ' + selectedIconBorderColor
                    : '',
                backgroundColor:
                  menuItem.id === activeTool || menuItem.id === centerActiveTool ? selectedIconBackgroundColorFooter : '',
              }"
              @click="startTool(menuItem)">
              <v-btn icon>
                <BaseTooltip top>
                  <template #activator="{on, attrs}">
                    <v-icon
                      v-bind="attrs"
                      :color=" menuItem.id === activeTool || menuItem.id === centerActiveTool ? selectedIconColor : iconColor"
                      v-on="on">
                      {{ menuItem.icon }}
                    </v-icon>
                  </template>
                  <span>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</span>
                </BaseTooltip>
              </v-btn>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'ToolList',
  props: {
    isToolListText: { type: Boolean, default () { return false } },
    isToolListLeft: { type: Boolean, default () { return false } },
    isToolListRight: { type: Boolean, default () { return false } },
    isToolListFooter: { type: Boolean, default () { return false } },
    isToolListDialog: { type: Boolean, default () { return false } },
    isToolListCollapsedText: { type: Boolean, default () { return false } },
  },
  data () {
    return {
      configJson: {},
    }
  },
  computed: {
    shrinkToXS () {
      return this.$vuetify.breakpoint.xsOnly
    },
    activeTool () {
      return this.$store.getters.getActiveTool
    },
    centerActiveTool () {
      return this.$store.getters.getCenterActiveTool
    },
    viewType () {
      return this.$store.getters.getViewType
    },
    menuItemsTools () {
      const widgets = []
      if (this.isToolListText && this.configJson.appConfig.widgetGroups) {
        for (const item of this.configJson.appConfig.widgetGroups) {
          const group = { group: true, title: item.title[this.$store.getters.getLanguage] }
          widgets.push(group)
          for (const widget of item.widgets) {
            if (widget.title) {
              const pomWidgets = []
              for (const wid of widget.widgets) {
                if (!this.$store.getters.getForbiddenWidgets?.[wid]) {
                  pomWidgets.push(wid)
                }
                widget.widgets = pomWidgets
              }
              widgets.push({
                title: widget.title[this.$store.getters.getLanguage],
                tooltip: widget.title,
                icon: widget.icon,
                widgets: widget.widgets,
                position: 'side',
                subgroup: true,
              })
            } else {
              const index = this.menuItems.findIndex((x) => x.id === widget)
              const configWidget = this.configJson.widgets.find((x) => x.id === widget && x.configured)
              if (index !== -1 && configWidget && !this.$store.getters.getForbiddenWidgets?.[widget]) {
                widgets.push(this.menuItems[index])
              } else {
                const customTools = this.configJson.customTools
                const customTool = customTools?.find((x) => x.id === widget)
                if (customTool && !this.$store.getters.getForbiddenWidgets?.[widget]) {
                  widgets.push({
                    id: customTool.id,
                    title: customTool.id,
                    icon: customTool.icon,
                    tooltip: customTool.title,
                    position: customTool.position,
                  })
                }
              }
            }
          }
        }
        return widgets
      }

      if (this.configJson.widgets) {
        for (const widget of this.configJson.widgets) {
          if (widget.configured && !this.$store.getters.getForbiddenWidgets?.[widget.id]) {
            if (widget.id === 'editor' && (this.$store.getters.getHasLogin === 0 || (this.$store.getters.getHasLogin === 2 && !this.$store.getters.getLoggedInUser) || this.$store.getters.getLicense !== 'Advanced')) continue
            const index = this.menuItems.findIndex((x) => x.id === widget.id)
            if (index !== -1 && this.menuItems[index].id !== 'identify') {
              widgets.push(this.menuItems[index])
            }
          }
        }
      }
      // check config.json
      // find customTools
      // iterate throw array and add tools in widgets array
      let customTools = this.configJson.customTools
      if (customTools) {
        customTools = customTools.filter(element => element.btnPosition === 'toolList')
        if (customTools.length > 0) {
          let index = this.menuItems.length
          for (const customTool of customTools) {
            if (!this.$store.getters.getForbiddenWidgets?.[customTool.id]) {
              widgets.push({
                index: index,
                id: customTool.id,
                title: customTool.id,
                icon: customTool.icon,
                tooltip: customTool.title,
                position: customTool.position,
              })
            }
            index = index + 1
          }
        }
      }
      return widgets
    },
    menuItems () {
      return [
        {
          index: 0,
          id: 'gotoxy',
          title: 'Tool 1',
          icon: 'mdi-map-marker',
          tooltip: this.labels.gotoxy,
          position: 'side',
        },
        {
          index: 1,
          id: 'toc',
          title: 'Tool 2',
          icon: 'mdi-format-list-bulleted',
          tooltip: this.labels.toc,
          position: 'side',
        },
        {
          index: 2,
          id: 'basemap',
          title: 'Tool 3',
          icon: 'mdi-map-outline',
          tooltip: this.labels.basemap,
          position: 'side',
        },
        {
          index: 3,
          id: 'identify',
          title: 'Tool 4',
          icon: 'mdi-card-text',
          tooltip: this.labels.identify,
          position: 'side',
        },
        {
          index: 4,
          id: 'search',
          title: 'Tool 5',
          icon: 'mdi-layers-search-outline',
          tooltip: this.labels.search,
          position: 'side',
        },
        {
          index: 5,
          id: 'spatialSelection',
          title: 'Tool 6',
          icon: 'mdi-selection-search',
          tooltip: this.labels.spatialSelection,
          position: 'side',
        },
        {
          index: 6,
          id: 'bookmarks',
          title: 'Tool 7',
          icon: 'mdi-bookmark-outline',
          tooltip: this.labels.bookmarks,
          position: 'side',
        },
        {
          index: 7,
          id: 'status',
          title: 'Tool 8',
          icon: 'mdi-layers-outline',
          tooltip: this.labels.status,
          position: 'side',
        },
        {
          index: 8,
          id: 'print',
          title: 'Tool 9',
          icon: 'mdi-printer',
          tooltip: this.labels.print,
          position: 'side',

        },
        {
          index: 9,
          id: 'measure',
          title: 'Tool 10',
          icon: 'mdi-ruler-square-compass',
          tooltip: this.labels.measure,
          position: 'side',
        },
        {
          index: 10,
          id: 'views',
          title: 'Tool 11',
          icon: 'mdi-eye-outline',
          tooltip: this.labels.views,
          position: 'side',
        },
        {
          index: 11,
          id: 'linearReferencing',
          title: 'Tool 12',
          icon: 'mdi-vector-polyline-edit',
          tooltip: this.labels.linearReferencing,
          position: 'side',
        },
        {
          index: 12,
          id: 'spatialRelation',
          title: 'Tool 13',
          icon: 'mdi-vector-intersection',
          tooltip: this.labels.spatialRelation,
          position: 'side',
        },
        {
          index: 13,
          id: 'draw',
          title: 'tool 14',
          icon: 'mdi-brush',
          tooltip: this.labels.draw,
          position: 'side',
        },
        {
          index: 14,
          id: 'editor',
          title: 'tool 15',
          icon: 'mdi-layers-edit',
          tooltip: this.labels.editor,
          position: 'side',
        },
        {
          index: 15,
          id: 'elevation',
          title: 'tool 16',
          icon: 'mdi-elevation-rise',
          tooltip: this.labels.elevation,
          position: 'side',
        },
        {
          index: 16,
          id: 'export',
          title: 'tool 17',
          icon: 'mdi-download-outline',
          tooltip: this.labels.export,
          position: 'side',
        },
        {
          index: 17,
          id: 'import',
          title: 'tool 18',
          icon: 'mdi-upload-outline',
          tooltip: this.labels.import,
          position: 'side',
        },
        {
          index: 18,
          id: 'driveAnalysis',
          title: 'tool 19',
          icon: 'mdi-radius-outline',
          tooltip: this.labels.driveAnalysis,
          position: 'side',
        },

      ]
    },
    language () {
      return this.$store.getters.getLanguage
    },
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).toolList
    },
    colorSchema () {
      return this.$store.getters.getConfigJson.colorSchema
    },
    iconColor () {
      return this.colorSchema.widgetsListIcons
    },
    selectedIconColor () {
      return this.colorSchema.widgetsListIcons
    },
    selectedIconBackgroundColorFooter () {
      return this.selectedIconColor + '32'
    },
    selectedIconBorderColor () {
      return this.colorSchema.elements
    },
    denseToolbox () {
      return this.configJson.layout.denseToolbox
    },
  },
  created () {
    this.configJson = this.$store.getters.getConfigJson
  },
  methods: {
    startTool (item) {
      if (item.subgroup) {
        this.$emit('open-subgroup', item)
        return
      }
      if (item.position === 'side') {
        if (item.id === this.activeTool) {
          this.$store.dispatch('unSetActiveTool')
        } else {
          this.$store.dispatch('setActiveTool', item.id)
          if (this.isToolListDialog && !this.shrinkToXS) {
            this.$emit('close-dialog')
          }
        }
      } else if (item.id === this.centerActiveTool) {
        this.$store.dispatch('unStoreCenterActiveTool')
      } else {
        this.$store.dispatch('storeCenterActiveTool', item.id)
        if (this.isToolListDialog && !this.shrinkToXS) {
          this.$emit('close-dialog')
        }
      }
    },
  },
}
</script>
